<template>
  <div>
    <NavigationBar
      titel="Zielvorgabe anlegen"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="createItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <performance-target-editor
          v-model="performanceTarget"
          mode="new"
        ></performance-target-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { Timestamp } from "@/firebase";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { CREATE_PERFORMANCE_TARGET } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import PerformanceTargetEditor from "@/components/member-management/performance-targets/PerformanceTargetEditor.vue";

export default {
  name: "member-management-performance-targets-new",
  components: {
    NavigationBar,
    PerformanceTargetEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          actionStyle: "textBtnSubmit",
          function: this.createItem,
        },
      ],
      performanceTarget: {
        title: "",
        shortTitle: "",
        description: "",
        sortKey: Number,
        isActive: true,
        requiredForLevel: null,
        conditions: { logicalOperator: "all", conditions: [] },
        applicableDivisionIds: [],
        monitoringInterval: { value: null, unit: null },
        dataVariables: [],
        primaryDataVariable: null,
        targetValue: { value: null, unit: null },
        validFrom: { date: null, time: "00:00" },
        validUntil: { date: null, time: "23:59" },
      },
      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {
    newSortKey() {
      return this.$store.state.memberManagement.performanceTargets.length + 1;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.performanceTarget.sortKey = this.newSortKey;
    },
    validate() {
      this.$refs.form.validate();
    },
    createItem() {
      this.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(
          `${MEMBER_MANAGEMENT}${CREATE_PERFORMANCE_TARGET}`,
          {
            organizationId: this.$route.params.organizationId,

            title: this.performanceTarget.title,
            shortTitle: this.performanceTarget.shortTitle,
            sortKey: this.performanceTarget.sortKey,
            isActive: this.performanceTarget.isActive,
            requiredForLevel: this.performanceTarget.requiredForLevel,
            validFrom: {
              timestamp: this.convertToTimestamp(
                this.performanceTarget.validFrom.date,
                this.performanceTarget.validFrom.time
              ),
            },
            validUntil: {
              timestamp: this.convertToTimestamp(
                this.performanceTarget.validUntil.date,
                this.performanceTarget.validUntil.time
              ),
            },
            applicableDivisionIds: this.performanceTarget.applicableDivisionIds,
            monitoringInterval: {
              unit: this.performanceTarget.monitoringInterval.unit,
              value: this.performanceTarget.monitoringInterval.value,
            },
            dataVariables: this.performanceTarget.dataVariables,
            primaryDataVariable: this.performanceTarget.primaryDataVariable,
            targetValue: this.performanceTarget.targetValue,
            conditions: {
              logicalOperator:
                this.performanceTarget.conditions.logicalOperator,
              conditions: this.performanceTarget.conditions.conditions,
            },
          }
        );
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
  },
};
</script>

<style></style>
